import React from 'react';
import './Games.css';
import iconGooglePlay from '../assets/icon_googleplay.webp';
import prod2048 from '../assets/prod_2048.webp';
import prodBallSortMania from '../assets/prod_BallSortMania.webp';
import prodBlockWoodPuzzle from '../assets/prod_BlockWoodPuzzle.webp';
import prodBoxSortColorMaster from '../assets/prod_BoxSortColorMaster.webp';
import prodBubblePopBlitz from '../assets/prod_BubblePopBlitz.webp';
import prodNuttySort from '../assets/prod_NuttySort.webp';
import prodSudokuSprint from '../assets/prod_SudokuSprint.webp';

const Games = () => {
  const games = [
    {
      title: 'Color Box - Sort Puzzle',
      category: 'Puzzle',
      downloads: 'New',
      rating: 4.8,
      description: 'Dive into a satisfying color box sorting challenge!',
      features: ['Color Sorting', 'Relaxing Puzzle', 'Smooth Gameplay', 'Brain Training'],
      image: prodBoxSortColorMaster,
      googlePlayUrl: 'https://play.google.com/store/apps/details?id=com.jiutiantech.boxsort'
    },
    {
      title: '2048',
      category: 'Puzzle',
      downloads: '25M+',
      rating: 4.9,
      description: 'The classic number puzzle game that started it all. Swipe to combine tiles and reach the elusive 2048 tile in this addictive mathematical challenge.',
      features: ['Classic Gameplay', 'Undo Function', 'Best Score Tracking', 'Smooth Animations'],
      image: prod2048
    },
    {
      title: 'Ball Sort Mania',
      category: 'Puzzle',
      downloads: '18M+',
      rating: 4.8,
      description: 'Sort colorful balls into matching tubes in this satisfying and relaxing puzzle game. Perfect for unwinding while exercising your brain.',
      features: ['1000+ Levels', 'No Time Limit', 'Hint System', 'Offline Play'],
      image: prodBallSortMania
    },
    {
      title: 'Block Wood Puzzle',
      category: 'Puzzle',
      downloads: '22M+',
      rating: 4.7,
      description: 'Classic wooden block puzzle game with beautiful graphics. Drag and drop blocks to create and clear full lines in this timeless puzzle experience.',
      features: ['Endless Mode', 'Daily Challenges', 'Beautiful Wood Theme', 'Relaxing Music'],
      image: prodBlockWoodPuzzle
    },
    {
      title: 'Bubble Pop Blitz',
      category: 'Casual',
      downloads: '30M+',
      rating: 4.8,
      description: 'Pop colorful bubbles in this fast-paced and exciting bubble shooter game. Match colors and create powerful combos to clear the board.',
      features: ['Power-up Bubbles', 'Special Effects', 'Level Editor', 'Social Leaderboards'],
      image: prodBubblePopBlitz
    },
    {
      title: 'Nutty Sort',
      category: 'Puzzle',
      downloads: '15M+',
      rating: 4.6,
      description: 'Sort nuts and bolts by color and size in this engaging sorting puzzle game. Train your logical thinking with increasingly complex challenges.',
      features: ['Progressive Difficulty', 'Multiple Sorting Types', 'Achievement System', 'Color Blind Support'],
      image: prodNuttySort
    },
    {
      title: 'Sudoku Sprint',
      category: 'Puzzle',
      downloads: '12M+',
      rating: 4.9,
      description: 'The ultimate Sudoku experience with multiple difficulty levels and smart hints. Perfect your logic skills with this classic number puzzle.',
      features: ['4 Difficulty Levels', 'Smart Hints', 'Error Detection', 'Statistics Tracking'],
      image: prodSudokuSprint
    }
  ];

  return (
    <section id="games" className="games section">
      <div className="container">
        <div className="games-header">
          <h2 className="section-title">Our Games Portfolio</h2>
          <p className="section-subtitle">
            Discover our collection of successful hyper-casual games that have captured the hearts of millions of players worldwide
          </p>
        </div>

        <div className="games-grid">
          {games.map((game, index) => (
            <div key={index} className="game-item">
              <div className="game-card" style={{backgroundImage: `url(${game.image})`}}>
                <div className="game-overlay"></div>
              </div>
              
              <div className="game-info-bottom">
                <div className="game-title-section">
                  <h3 className="game-title">{game.title}</h3>
                </div>
                
                <div className="game-description-section">
                  <p className="game-description">{game.description}</p>
                  {game.googlePlayUrl && (
                    <div className="game-actions">
                      <a
                        className="platform-badge game-download-link"
                        href={game.googlePlayUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={`Get ${game.title} on Google Play`}
                      >
                        <img src={iconGooglePlay} alt="" aria-hidden="true" />
                        <span>Google Play</span>
                      </a>
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="games-cta">
          <h3>Want to see more of our games?</h3>
          <p>We're constantly developing new and exciting hyper-casual games. Stay tuned for upcoming releases!</p>
        </div>
      </div>
    </section>
  );
};

export default Games;
